import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-form-control-hint',
  imports: [],
  templateUrl: './form-control-hint.component.html',
  styleUrls: ['./form-control-hint.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormControlHintComponent {
  public readonly hint = input.required<string>();
}
